<label
  [ngClass]="'input-wrap radio custom' + labelBaseClass"
  [class.required]="isRequired"
  [class.disabled]="disabled"
  [class.checked]="model === checkedValue"
>
  <input type="radio" (click)="onValueChanged()" />
  <span class="text">
    <ng-content></ng-content>
  </span>
</label>
<!-- [(ngModel)]="value" -->
